import { render, staticRenderFns } from "./ParamsFormItem.vue?vue&type=template&id=34e5e41d"
import script from "./ParamsFormItem.vue?vue&type=script&lang=js"
export * from "./ParamsFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports